// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1-ipe","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1vhFU","obliqueLine":"membershipbadge_obliqueLine__2BFSm"};